/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type VestingAllocationInput = {
  beneficiary: Address;
  scheduleId: number;
  amount: bigint;
};

export type VestingAllocationInputArgs = {
  beneficiary: Address;
  scheduleId: number;
  amount: number | bigint;
};

export function getVestingAllocationInputEncoder(): FixedSizeEncoder<VestingAllocationInputArgs> {
  return getStructEncoder([
    ['beneficiary', getAddressEncoder()],
    ['scheduleId', getU8Encoder()],
    ['amount', getU64Encoder()],
  ]);
}

export function getVestingAllocationInputDecoder(): FixedSizeDecoder<VestingAllocationInput> {
  return getStructDecoder([
    ['beneficiary', getAddressDecoder()],
    ['scheduleId', getU8Decoder()],
    ['amount', getU64Decoder()],
  ]);
}

export function getVestingAllocationInputCodec(): FixedSizeCodec<
  VestingAllocationInputArgs,
  VestingAllocationInput
> {
  return combineCodec(
    getVestingAllocationInputEncoder(),
    getVestingAllocationInputDecoder(),
  );
}
